import { render, staticRenderFns } from "./CampaignCard.vue?vue&type=template&id=75ed78f5&scoped=true&"
import script from "./CampaignCard.vue?vue&type=script&lang=js&"
export * from "./CampaignCard.vue?vue&type=script&lang=js&"
import style0 from "./CampaignCard.vue?vue&type=style&index=0&id=75ed78f5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ed78f5",
  null
  
)

export default component.exports